













import { Teacher } from '../../../src_server/entity/generated/Teacher';
import { Vue, Component, Prop } from 'vue-property-decorator';
import CommonDialog from '../../components/organisms/CommonDialog.vue';
import CommonTable, { TableColumn } from '../../components/organisms/CommonTable.vue';

import { ReportDTO } from '../../../src_server/entity/dto/ReportDTO';
import { MessageDialog } from '../../utils/MessageDialog';
import { routeHelper } from '../../utils/routeHelper';
import PrimaryButton from '../../components/button/PrimaryButton.vue';
import { dayjs, DTW_FORMAT_JA_SHORT } from '../../../src_server/common/momentExtends';
import { LessonsService } from '../../biz/remote/LessonsService';
import { LessonDTO } from '../../../src_server/entity/dto/LessonDTO';
import { Session } from '../../utils/Session';

@Component({ components: { CommonDialog, CommonTable } })
export default class LessonLogDialog extends Vue {
  private teacher: Teacher = new Teacher();
  private list: LessonDTO[] = [];

  private get title() {
    return this.teacher.nickname + `さんのレッスン履歴`;
  }

  public cols: TableColumn[] = [
    { label: 'no', type: 'seq', width: '75px' },
    { label: 'ニックネーム', name: 'student.nickname', width: '125px' },
    {
      label: '日付',
      type: 'datetime',
      name: 'lessons.start_dt',
      width: '120px',
    },
    { label: '予約状態', name: 'lessons.reservation_state', width: '125px' },
    {
      label: 'レッスンを削除する',
      type: 'button',
      width: '120px',
      btnClass: PrimaryButton.CSS,
      onclick: this.deleteLesson,
    },
  ];

  async loadData(teacher: Teacher) {
    console.log('test');
    if (!teacher.user_id) {
      await MessageDialog.systemError('先生のユーザーID', '日報履歴表示時');
      return;
    }

    const biz = new LessonsService();
    const response = await biz.getLessonsByTeacher(teacher.user_id);
    this.list = response.data.sort((a, b) => {
      if (!a.student?.nickname || !b.student?.nickname) {
        return 0;
      }
      if (a.student.nickname !== b.student.nickname) {
        // 文字列は大小で比較する必要がある
        if (a.student.nickname > b.student.nickname) return 1;
        if (a.student.nickname < b.student.nickname) return -1;
      }
      return dayjs(b.lessons.start_dt).diff(dayjs(a.lessons.start_dt));
    });
  }

  async deleteLesson(row: LessonDTO) {
    const isOK = await MessageDialog.confirm(
      `先生:${row.teacher?.nickname},生徒:${row.student?.nickname}の${dayjs(row.lessons.start_dt).format(DTW_FORMAT_JA_SHORT)}のレッスンをキャンセルします。よろしいですか？`
    );
    if (isOK) {
      const biz = new LessonsService();
      const response = await biz.cancel(row.lessons.class_id!, Session.getSessionBuildingId(), `${dayjs().format(DTW_FORMAT_JA_SHORT)}に、運営によりキャンセル`);
      if (response.hasError) {
        await MessageDialog.alert(`${response.errorDescription}`);
        return;
      }
      await MessageDialog.alert(`レッスンをキャンセルしました。`);
      // リロード
      await this.loadData(this.teacher);
    }
  }

  /**
   * 表示
   */
  public show(row: Teacher) {
    this.teacher = row;
    this.loadData(row).then();

    const dialog = this.$refs['LessonLogDialog'] as CommonDialog;
    dialog.show();
  }

  /**
   * 隠す
   */
  hide() {
    const dialog = this.$refs['LessonLogDialog'] as CommonDialog;
    dialog.hide();
  }
}
